import React from 'react'
import SearchNav from '../../SearchNav/SearchNav'

const Document = () => {
  return (
    <div>
        <SearchNav/>
        <h1 className='p-3'>Document</h1>
    </div>
  )
}

export default Document